import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import Grid from '@material-ui/core/Grid';

import validator from 'validator';
import Warning from './WarningComponent';

import { CALCULATION_FLOWRATE_TYPE_KG_TO_S, CALCULATION_FLOWRATE_TYPE_M3_TO_H, CALCULATION_FLOWRATE_TYPE_L_TO_S, CALCULATION_FLOWRATE_TYPE_M_TO_S } from '../modules/calculation';

import { getUIText } from '../utils/index';

const checkWarnings = (min, max, value, ) => {
  if(min != undefined && Number(value) < Number(min)) {
    return {warning: true, warningText: 'GENERAL-MINIMUM_VALUE', value};
  } else  if(max != undefined && Number(value) > Number(max)) {
    return {warning: true, warningText: 'GENERAL-MAXIMUM_VALUE', value};
  } else {
    return {warning: true, warningText: 'GENERAL-NOT_VALID_VALUE', value};
  }
};

class FlowrateComponent extends Component {
/*   state = {
    anchorEl: undefined,
    open: false,
    value: null,
    previousValidValue: null,
    warning: false,
    warningText: ""
  }; */
  constructor(props) {
    super(props);
    const result = this.checkValues(this.props);
    if(!result) {
      this.state = {
        anchorEl: undefined,
        open: false,
        value: '',
        previousValidValue: null,
        warning: false,
        warningText: ''
      };
    } else {
      this.state = {
        anchorEl: undefined,
        open: false,
        value: '',
        previousValidValue: null,
        warning: result.warning,
        warningText: result.warningText
      };
    }
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = (item, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.setState({ open: false});
    if (this.props.onTypeChange && item) {
      this.props.onTypeChange(item);
    }
  };

  handleChange = event => {
    if(!this.props) return;
    const {min, max, type, app, translations} = this.props;

    let options = {};
    if(min != undefined) {
      options.min = Number(min);
    }

    if(max != undefined) {
      options.max = Number(max);
    }

    if(!validator.isInt(event.target.value, {...options, allow_leading_zeroes: false}) && !validator.isFloat(event.target.value, options)) {
/*       console.log("--> " + min)
      console.log("--> " + event.target.value)

      console.log((min)) */
      const {warning, warningText, value } = checkWarnings(min, max, event.target.value);
      if(warning) {
        this.setState({warning: true, warningText: getUIText(warningText, app.language, translations) + min, value});
      }

/*       if(min != undefined && Number(event.target.value) < Number(min)){
        this.setState({warning: true, warningText: "Minimum value is: " + min, value:event.target.value})
      } else  if(max != undefined && Number(event.target.value) > Number(max)){
        this.setState({warning: true, warningText: "Maximum value is: " + max, value:event.target.value})
      } else {
        this.setState({warning: true, warningText: "Not valid value!", value:event.target.value})
      } */
      return;
    }

    this.setState({warning: false, value: null, previousValidValue: event.target.value});
    if (this.props.onInputChange) {
      this.props.onInputChange(event.target.value);
    }
  }

  handleOnKeyPress = event => {
    const {unit, type, min, max} = this.props;
    const charCode = event.keyCode || event.which;

    // Mobile enter click
    if(charCode === 13) {
      document.activeElement.blur();
      event.preventDefault();
      return;
    }
  }

  onClick = event => {
    if (this.input && this.input.focus) {
      this.input.focus();
    }
  }

  refFunc = target => {
    // Avoid setState() in ref callbacks; it can cause render loops.
    this.input = target;
  }

  onBlurHandler = target => {
    if(!this.props) return;
    if(this.state.warning) {
      if (this.props.onInputChange && this.state.previousValidValue != undefined) {
        this.setState({warning: false, value: null});
        this.props.onInputChange(this.state.previousValidValue);
      }
    }
  }

  checkValues = (props) =>{
    const {value, flowRate, label, unit, type, className, max, min, disabled, unitType, thicknessAlert, translations, app} = this.props;

    if(type === 'string') {
      return false;
    }

    let options = {};
    if(min != undefined) {
      options.min = Number(min);
    }

    if(max != undefined) {
      options.max = Number(max);
    }
    if(!validator.isInt(flowRate.toString(), {...options, allow_leading_zeroes: false}) && !validator.isFloat(flowRate.toString(), options)) {
      const {warning, warningText, value } = checkWarnings(min, max, flowRate);

      if(warning) {
        return ({warning: true, warningText: getUIText(warningText, app.language, translations) + min, value });
      }
      return false;
    }
  }

  render() {
    const {data, flowRate, selectedItem} = this.props;

    let selectedItemName;
    const menuItems = data.map(option => {
      if(selectedItem && option.id === selectedItem) {
        selectedItemName = option.name;
      }
      return (<MenuItem key={option.id} style={{display: 'block'}} selected={selectedItem ? option.id === selectedItem : false} onClick={this.handleRequestClose.bind(this, option.id)}>
        {option.name}
      </MenuItem>);
    });

    let unit = 'kg/s';
    if(selectedItem === CALCULATION_FLOWRATE_TYPE_KG_TO_S) {
      unit = 'kg/s';
    } else if (selectedItem === CALCULATION_FLOWRATE_TYPE_M3_TO_H) {
      unit = 'm³/h';
    } else if (selectedItem === CALCULATION_FLOWRATE_TYPE_L_TO_S) {
      unit = 'l/s';
    } else if (selectedItem === CALCULATION_FLOWRATE_TYPE_M_TO_S) {
      unit = 'm/s';
    }

    let inputValue = flowRate;
    if(inputValue === undefined || inputValue === null) {
      inputValue = '';
    }

    return (
      <Grid className="flowrate animated fadeIn" container spacing={0} alignContent="stretch" >
        <Grid item xs={8} sm={6} md={8} >
          <div className="dropdownlist" onClick={this.handleClick}
              aria-owns={this.state.open ? 'simple-menu' : null}
              aria-haspopup="true">
            <div
              className="text" >
              <h5>{selectedItemName}</h5>
            </div>
            <div className="opener">
              <div className="btn">
                <i className="fa fa-chevron-down"></i>
              </div>
            </div>
            <Menu
              id="long-menu"
              anchorEl={this.state.anchorEl}
              open={this.state.open}
              variant="menu"
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              onClose={this.handleRequestClose.bind(this, null)}
              MenuListProps={{
                style: {
                  width: 270,
                  maxHeight: 400
                },
              }}
            >
              {menuItems}
            </Menu>
          </div>
        </Grid>

        <Grid item xs={4} sm={6} md={4} >
          <div className="input-container" onClick={this.onClick.bind(this)}>
            <Input
              className="input-holder"
              inputRef={this.refFunc.bind(this)}
              value={this.state.warning ? this.state.value : inputValue}
              inputProps={{type: 'number', pattern: '\d*'}}
              onChange={this.handleChange}
              onKeyPress={this.handleOnKeyPress}
              onBlur={this.onBlurHandler.bind(this)} />
            <span>{unit}</span>
            <Warning visible={this.state.warning} info={this.state.warningText}/>
          </div>
        </Grid>
      </Grid>
    );
  }
}

FlowrateComponent.propTypes = {

  onTypeChange: PropTypes.any,
  min: PropTypes.any,
  max: PropTypes.any,
  type: PropTypes.any,
  app: PropTypes.any,
  translations: PropTypes.any,
  onInputChange: PropTypes.any,
  unit: PropTypes.any,
  value: PropTypes.any,
  flowRate: PropTypes.any,
  label: PropTypes.any,
  className: PropTypes.any,
  disabled: PropTypes.any,
  unitType: PropTypes.any,
  thicknessAlert: PropTypes.any,
  data: PropTypes.any,
  selectedItem: PropTypes.any,
};

export default FlowrateComponent;
